import { useEffect, useState, type FormEvent } from "react";

const SUBMIT_ADDR = "https://readdy.ai/api/form/dag3p81tto0ceqqnhlag";

interface NewsletterFormProps {
  compact?: boolean;
  className?: string;
}

export default function NewsletterForm({ compact = false, className = "" }: NewsletterFormProps) {
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);
    const honeypot = (data.get("company_alt") as string) || "";

    const email = (data.get("email") as string) || "";
    const payload = new URLSearchParams();
    payload.set("email", email);

    // 蜜罐字段为空时正常提交；非空则静默按成功处理
    if (honeypot.trim()) {
      setStatus("success");
      setMessage("感谢订阅，最新爆料将第一时间送达！");
      form.reset();
      return;
    }

    try {
      const response = await fetch(SUBMIT_ADDR, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });
      const text = await response.text();
      let parsed: Record<string, unknown> | null = null;
      try {
        parsed = JSON.parse(text);
      } catch {
        parsed = null;
      }
      const meta = parsed?.meta as Record<string, unknown> | undefined;
      const code = parsed?.code as string | undefined;
      const serverMsg =
        (meta?.message as string) ||
        (parsed?.message as string) ||
        (meta?.detail as string) ||
        text;
      const isSpam = /spam/i.test(`${serverMsg}`);

      if (response.ok && code === "OK" && !isSpam) {
        setStatus("success");
        setMessage("感谢订阅，最新爆料将第一时间送达！");
        form.reset();
      } else {
        setStatus("error");
        setMessage(
          isSpam || !serverMsg || serverMsg === "[object Object]"
            ? "订阅未成功，请稍后再试。"
            : serverMsg,
        );
      }
    } catch {
      setStatus("error");
      setMessage("网络异常，请稍后再试。");
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      data-readdy-form="newsletter"
      className={className}
      aria-label="订阅娱乐爆料资讯"
    >
      <input
        type="text"
        name="company_alt"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
        className="honeypot-guard"
        value=""
      />
      <div
        className={`flex w-full gap-2 ${compact ? "flex-col sm:flex-row" : "flex-col sm:flex-row"}`}
      >
        <label htmlFor="newsletter-email" className="sr-only">
          邮箱地址
        </label>
        <input
          id="newsletter-email"
          type="email"
          name="email"
          required
          placeholder="输入你的邮箱，接收每日爆料"
          className="min-w-0 flex-1 rounded-md border border-background-300 bg-background-50 px-4 py-3 text-sm text-foreground-900 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
        />
        <button
          type="submit"
          className="shrink-0 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 focus:ring-2 focus:ring-primary-300"
        >
          立即订阅
        </button>
      </div>
      {status === "success" && (
        <p className="mt-3 text-sm font-medium text-secondary-600" role="status">
          {message}
        </p>
      )}
      {status === "error" && (
        <p className="mt-3 text-sm font-medium text-primary-700" role="alert">
          {message}
        </p>
      )}
    </form>
  );
}